// ReactPlayer Component

import React, { Component } from 'react'
import ReactPlayer from 'react-player'

import Dialog from '../layout/dialog/dialog.jsx'
import Button from '../common/button/button.jsx'

class Player extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      url: null
    }
  }

  show (url) {
    this.setState({ active: true, url: url })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal
        type='video'
      >
        <div className='dialog-actionboard dialog-video'>
          <ReactPlayer url={this.state.url} playing controls />
          <div className='actionboard-footer video-footer'>
            <Button
              className='button_help button_skipvideo'
              title='common.help.skipVideo'
              type='button'
              icon='help-tip-next'
              onClick={this.hide.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}

export default Player
